var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StateAnalysis',{attrs:{"title":"睡眠评价报告","report":"smReportHistories"}})
}
var staticRenderFns = []

export { render, staticRenderFns }